import { API } from "aws-amplify";

const send = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };

  let res = await API.post("InasakuAPI", "/api/inquiry", myInit);

  return res;
};


export default {
  send,
};
